import { useState } from "react";
import { Link } from "easy-page-router/react";

import { Header } from "../Layout";
import { LangSwitch } from "../components/Lang";
import { ThemeSwitch } from "../components/Theme";
import { Loading, Page } from "../components";
import { useHead } from "../services/common";
import { useLang } from "../services/lang";
import { handleError } from "../services/api";
import { Input } from "../components/Form";
import { useUser } from "../components/User";

export default function ForgottenPassword({ token }: { token: string }) {
    const { dict } = useLang();
    const { loginUser, api: authClient } = useUser();

    useHead({
        title: dict.seo.forgottenPassword.title,
        description: dict.seo.forgottenPassword.description,
    });

    const [password, setPassword] = useState({ password: "", passwordAgain: "" });
    const [message, setMessage] = useState("");
    const [isSending, setIsSending] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);


    let sendMessage = "";
    if (password.password !== password.passwordAgain)
        sendMessage = dict.userWrongPasswordMatch;
    if (password.passwordAgain.length < 1)
        sendMessage = dict.userWrongPasswordAgain;
    if (password.password.length < 6)
        sendMessage = dict.userWrongPasswordLength;

    async function handleSend() {
        if (sendMessage) return;

        setIsSending(true);
        setMessage("");

        const [user, error] = await authClient.updateForgottenPassword({ ...password, token });
        if (error) {
            handleError(error);
            setMessage(dict.userForgottenPasswordErrorChange);
        } else if (user) {
            loginUser(user);
            setIsSuccess(true);
        }

        setIsSending(false);
    }

    return <Page fixed={<>
        <Header title={dict.donate} link={`/${dict.urlDonate}`}>
            <LangSwitch />
            <ThemeSwitch />
        </Header>
    </>}>
        <div style={{ width: 500, margin: "0 auto" }}>
            <h1>{dict.userForgottenPassword}</h1>

            {isSuccess && <>
                <p className="page-description">{dict.userForgottenPasswordSuccessChange}</p>
                <Link className="block" href="/">{dict.backToHome}</Link>
            </>}
            {!isSuccess && <>
                <p className="page-description">{dict.seo.forgottenPassword.text}</p>

                <Input label="Heslo" type="password" field="password" value={password} setValue={setPassword} maxLength={50} />
                <Input label="Heslo znovu" type="password" field="passwordAgain" value={password} setValue={setPassword} maxLength={50} />

                {message && <p className="alert">{message}</p>}

                {isSending && <Loading />}
                {!isSending && <>
                    <p className="info">{sendMessage || dict.allRight}</p>
                    <button disabled={!!sendMessage} className="width" onClick={handleSend}>
                        {dict.userForgottenPasswordChange}
                    </button>
                </>}
            </>}
        </div>
    </Page>;
}